import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ name: 'keyvalue' })
export class KeysPipe implements PipeTransform {
    transform(value, args: string[]): any {
        const items = [];
        // tslint:disable-next-line:forin
        for (const key in value) {
            items.push({
                key: key,
                value: value[key]
            });
        }
        return items;
    }
}



// WEBPACK FOOTER //
// ./src/app/_pipes/keyvalue.pipe.ts